module.exports = __webpack_public_path__ + "static/media/bg8.10c6490e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/minibg/bg8.jpg
// module id = 590
// module chunks = 0